import { render, staticRenderFns } from "./AppRenderer.vue?vue&type=template&id=13f639fc&scoped=true&lang=html&"
import script from "./AppRenderer.vue?vue&type=script&lang=js&"
export * from "./AppRenderer.vue?vue&type=script&lang=js&"
import style0 from "./AppRenderer.vue?vue&type=style&index=0&id=13f639fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f639fc",
  null
  
)

export default component.exports